import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Form } from "react-bootstrap";
import { fetchDashboardFeaturesdata } from "../../../redux/dashboard-features/featuresSlice";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import SelectDropdown from "../../components-react/SelectDropdown";
import { all_account_types } from "../../common-data/DropdowData";
import {
  add_feature_grouping,
  update_feature_grouping,
} from "../../../data/ApiEndpoints";

const FeatureGroupingForm = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    dashboardFeatures,
    dashboardFeaturesLoading,
    dashboardFeaturesError,
  } = useSelector((state) => state.features);

  const [allDashMenus, setAllDashMenus] = useState([]);
  const [filteredDashMenus, setFilteredDashMenus] = useState([]);
  const iniFormvalues = {
    groupName: isEdit && rowData?.name ? rowData.name : "",
    selectedAccountType:
      isEdit && rowData?.default_for
        ? {
            label: rowData?.default_for?.replace(/_/g, " "),
            value: rowData?.default_for,
          }
        : "",
    checkedPages:
      isEdit && rowData?.feature_ids
        ? rowData.feature_ids.map((feature) => feature.feature_id)
        : [],
    isActive: isEdit && rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [selectAll, setSelectAll] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onChangeInput = (e) => {
    const { id, checked } = e.target;

    setFormValues((prevs) => {
      let updatedCheckedPages;

      if (checked) {
        updatedCheckedPages = [...prevs.checkedPages, id];
      } else {
        updatedCheckedPages = prevs.checkedPages.filter(
          (pageId) => pageId !== id
        );
      }

      setSelectAll(updatedCheckedPages.length === allDashMenus.length);

      return {
        ...prevs,
        checkedPages: updatedCheckedPages,
      };
    });
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
  };

  const handleSelectAll = () => {
    if (selectAll) {
      const filteredIds = filteredDashMenus.map((item) => item.uid);
      setFormValues((prevs) => ({
        ...prevs,
        checkedPages: prevs.checkedPages.filter(
          (pageId) => !filteredIds.includes(pageId)
        ),
      }));
    } else {
      const filteredIds = filteredDashMenus.map((item) => item.uid);
      setFormValues((prevs) => ({
        ...prevs,
        checkedPages: [...new Set([...prevs.checkedPages, ...filteredIds])],
      }));
    }

    setSelectAll(!selectAll);
  };

  function validateForm(formValues) {
    let errors = {};

    if (!formValues.groupName) {
      errors.groupName = `required!`;
    }

    if (formValues.checkedPages?.length === 0) {
      errors.checkedPages = `required!`;
    }

    return errors;
  }

  const onSubmit = () => {
    setFormErrors(validateForm(formValues, isEdit));
    setIsSubmit(true);
  };

  function getDashboardMenus(filters) {
    dispatch(
      fetchDashboardFeaturesdata({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const handleAdd = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? update_feature_grouping : add_feature_grouping;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    const filters = {
      page: 1,
      limit: 1000,
      status: 1,
    };
    getDashboardMenus(filters);
  }, []);

  useEffect(() => {
    if (
      !dashboardFeaturesLoading &&
      !dashboardFeaturesError &&
      dashboardFeatures?.status &&
      dashboardFeatures?.data?.length > 0
    ) {
      setAllDashMenus(dashboardFeatures.data);
    } else {
      setAllDashMenus([]);
    }
  }, [dashboardFeatures, dashboardFeaturesLoading, dashboardFeaturesError]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        name: formValues.groupName || "",
        default_for: formValues.selectedAccountType?.value || "",
        feature_ids: formValues.checkedPages || [],
        status: formValues.isActive ? "active" : "inactive",
      };

      if (isEdit) userData.uid = rowData?.uid || "";

      const handleConfirm = async () => {
        handleAdd(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Confirm to ${isEdit ? "update" : "add new"} group`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    if (searchString?.trim()) {
      const filteredMenus = allDashMenus.filter((menu) =>
        menu.name.toLowerCase().includes(searchString.toLowerCase())
      );
      setFilteredDashMenus(filteredMenus);
      setSearchFilterApplied(true);
    } else {
      setFilteredDashMenus(allDashMenus);
      setSearchFilterApplied(false);
    }
  }, [searchString, allDashMenus]);

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title="Manage Feature Grouping"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <form className="formContainer">
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox span2">
            <label htmlFor="groupName" className={`formInputLabel`}>
              group name
              <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Feature Name"
              className={`formInput ${
                formErrors?.groupName ? "formError" : ""
              }`}
              name="groupName"
              value={formValues.groupName || ""}
              onChange={(e) =>
                setFormValues((prevs) => ({
                  ...prevs,
                  groupName: e.target.value,
                }))
              }
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedAccountType" className={`formInputLabel `}>
              Role
            </label>

            <div
              className={`commonWrapper ${
                formErrors?.selectedAccountType ? "formError" : ""
              }`}
            >
              <SelectDropdown
                options={all_account_types}
                selectedOption={formValues.selectedAccountType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedAccountType", selectedValue)
                }
                name="Role"
                isDisable={postPutLoading}
              />
            </div>
          </div>
        </div>

        <div className="wFull maxWidth50VW exportablesContainer">
          <label
            htmlFor="checkedPages"
            className="formInputLabel"
            style={{ marginBottom: "20px" }}
          >
            choose features to group
            <span className="required">*</span>
          </label>

          <div
            className={`inputCommonWrapper flexSpacebetween searchBarContainer ${
              searchFilterApplied ? "redBorderRedText" : ""
            }`}
          >
            <input
              type="search"
              className="input"
              placeholder="Search..."
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
            />
          </div>

          <div
            className="flexWrap mt30"
            style={{
              gap: "2rem",
              width: "100%",
              maxWidth: "100%",
              border: formErrors.checkedPages ? "2px solid red" : "",
              padding: formErrors.checkedPages ? "10px" : "",
              background: formErrors.checkedPages ? "#fff" : "",
              borderRadius: formErrors.checkedPages ? "10px" : "",
            }}
          >
            <Form.Check
              type="checkbox"
              id="select-all"
              label="Select All"
              checked={
                filteredDashMenus.length > 0 &&
                formValues.checkedPages.length === filteredDashMenus.length
              }
              onChange={handleSelectAll}
            />

            {filteredDashMenus?.length > 0 ? (
              filteredDashMenus.map((field, index) => (
                <Form.Check
                  key={index}
                  type={"checkbox"}
                  id={field?.uid}
                  label={field?.name}
                  checked={formValues.checkedPages.includes(field?.uid)}
                  onChange={onChangeInput}
                />
              ))
            ) : (
              <span className="noDataFound mt30">No Fields Found</span>
            )}
          </div>
        </div>

        <div className="formInputsGrid switchInputs">
          <div className="formInputBox formInputSwitchBox">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`${formValues.isActive ? "Active" : "Not Active"}`}
                checked={formValues.isActive}
                onChange={(e) =>
                  setFormValues((prev) => ({
                    ...prev,
                    isActive: e.target.checked,
                  }))
                }
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FeatureGroupingForm;
